import { NoddiBasicCard } from 'noddi-ui-web';
import type { PropsWithChildren } from 'react';

/** The picker's one shell, shared by its loading and loaded states so the first load does not shift the layout. */
export const TimeWindowPickerFrame = ({ isOnPage, children }: PropsWithChildren<{ isOnPage: boolean }>) =>
  isOnPage ? (
    <div className='flex flex-col gap-5'>{children}</div>
  ) : (
    <NoddiBasicCard className='flex flex-col gap-5 px-4 py-5 md:gap-4 md:p-6'>{children}</NoddiBasicCard>
  );
